import {useState} from "react";
import AccountService from "../../../services/account.service";
import RoleMultiSelect from "./RoleMultiSelect";
import {toast} from "react-hot-toast";

const InviteUserModal = ({onClose, onInvited, roles, organization}) => {
    const [users, setUsers] = useState([{
        firstName: '', 
        lastName: '', 
        email: '', 
        roleListIds: [], 
        roleList: [],
        roleListIdStr: []
    }]);
    const [sending, setSending] = useState(false);
    const handleChange = (index, field, value) => {
        setUsers(prev => prev
            .map((user, i) => (i === index ? {...user, [field]: value} : user))
        );
    };

    const handleRolesChange = ({index, roleList, roleListIds}) => {
        setUsers(prev => prev
            .map((user, i) => (i === index ? {
                ...user,
                roleList: roleList,
                roleListIds: roleListIds
            } : user))
        );
    }

    const handleAddUser = () => {
        setUsers(prev => [
            ...prev,
            {
                firstName: '',
                lastName: '',
                email: '',
                roleListIds: [],
                roleList: [],
                roleListIdStr: []
            }
        ]);
    };

    const handleRemoveUser = (index) => {
        setUsers(prev => prev
            .filter((_, i) => i !== index));
    };

    const handleSend = async () => {
        setSending(true);
        const payload = users.map((user) => ({
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            roleList: user.roleList.join(', '),
            roleListIds: user.roleListIds.join(', '),
            roleListIdStr: user.roleListIds.join(', ')
        }));
        const promise = AccountService.inviteusersloop(organization.name, organization.id, payload);
        toast.promise(promise, {
            loading: 'Sending changes...',
            success: 'The new user invites were sent successfully!',
            error: (err)=> err.message || 'Failed to send invites to the new users!'
        });

        try {
            const response = await promise;
            const defaultValue = {isActive: false, message: "No response from server."};
            const invitedUsers = users.map(user=>{
               const matchingResponse = response.data.find(res => res.email === user.email);
               return matchingResponse ? matchingResponse : {...user, ...defaultValue};
            });
            invitedUsers.forEach(user => {
                if(user.isActive){
                    toast.success(`Successfully sent invite to ${user.email}.`);
                } else {
                    toast.error(`Failed to send invite to ${user.email}. ${user.message}`);
                }
            });
        }catch(error) {
            console.log(error);
        }finally {
            setSending(false);
            onInvited();
            onClose();
        }
    };
    
    return (
        <div className="modal d-block">
            <div className="modal-wrapper translate-y-0">
                <div className="modal-header">
                    <h3>Invite New Users</h3>
                    <span className="close-modal-btn" onClick={onClose}>×</span>
                </div>

                <div className="px-3 py-3 text-start">
                    {users.map((user, index) => (
                        <div key={index} className="row">
                            <div className="col-sm-12 col-md-6">
                                <div>
                                    <p className="semibold">First Name:</p>
                                    <input
                                        type="text"
                                        name="firstName"
                                        className="form-control"
                                        value={user.firstName}
                                        onChange={(e) => handleChange(index, 'firstName', e.target.value)}
                                    />
                                </div>
                                <div>
                                    <p className="semibold">Last Name:</p>
                                    <input
                                        type="text"
                                        name="lastName"
                                        className="form-control"
                                        value={user.lastName}
                                        onChange={(e) => handleChange(index, 'lastName', e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <div>
                                    <p className="semibold">Roles:</p>
                                    <RoleMultiSelect
                                        roles={roles}
                                        value={user}
                                        onChange={(newRoles) => handleRolesChange({
                                            index: index,
                                            roleList: newRoles.roleList,
                                            roleListIds: newRoles.roleListIds
                                        })}
                                    />
                                </div>
                                <div>
                                    <p className="semibold">Email:</p>
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        value={user.email}
                                        onChange={(e) => handleChange(index, 'email', e.target.value)}
                                    />
                                </div>
                            </div>

                            {users.length > 1 && (
                                <div className="col-12">
                                    <button type="button" className="secondary-btn btn-small mt-3" onClick={() => handleRemoveUser(index)}>
                                        Remove User
                                    </button>
                                </div>
                            )}
                        </div>
                    ))}
                    <button type="button" className="btn-small secondary-btn mt-3" onClick={handleAddUser}>
                        + Add Another User
                    </button>
                </div>

                <div className="modal-footer">
                    <button className="secondary-btn btn-small" onClick={onClose} disabled={sending}>Cancel</button>
                    <button className="primary-btn btn-small" onClick={handleSend} disabled={sending}>
                        {sending ? 'Sending...' : 'Send Invites'}
                    </button>
                </div>
            </div>
        </div>
    );
}
export default InviteUserModal;